import React, { createContext, useContext, useState } from "react";

const ContactContext = createContext({ open: false, openContact: () => {}, closeContact: () => {}, setOpen: () => {} });

export const ContactProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const value = {
    open,
    setOpen,
    openContact: () => setOpen(true),
    closeContact: () => setOpen(false),
  };
  return <ContactContext.Provider value={value}>{children}</ContactContext.Provider>;
};

export const useContact = () => useContext(ContactContext);
